import Fetch from '../Fetch';

export default {
  queryLogs: () => {
    return Fetch.get(`/api/v1/logging`);
  },

  setLogs: (params) => {
    return Fetch.post(`/api/v1/logging`, params);
  },

  getLogList: (params) => {
    return Fetch.get(`/api/v1/bufferedLog`, { params });
  },

  downloadUrl: () => {
    return Fetch.get(`/api/v1/downloadLog`, { responseType: 'blob' });
  },

  clearLogs: (params) => {
    return Fetch.post(`/api/v1/clearBufferedLog`, params);
  },
};
